import React from 'react';
import PropTypes from 'prop-types';
import { Spin, Typography } from 'antd';

const AnalyticsCard = (props) => {
  const { title, statistic, isLoading } = props;

  return (
    <div
      style={{
        background: '#03304B',
        borderRadius: 6,
      }}
    >
      <div
        style={{
          borderBottom: '1px solid #4F6E81',
          padding: 15,
        }}
      >
        <Typography.Title
          level={5}
          style={{
            color: '#D9E0E4',
            margin: 0,
          }}
        >
          {title}
        </Typography.Title>
      </div>
      <div
        style={{
          color: '#D9E0E4',
          padding: 20,
        }}
      >
        <div
          style={{
            fontSize: 24,
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          {isLoading ? (
            <Spin />
          ) : (
            <>
              {statistic || 0}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

AnalyticsCard.propTypes = {
  title: PropTypes.string,
  statistic: PropTypes.string,
  isLoading: PropTypes.bool,
};

AnalyticsCard.defaultProps = {
  title: '',
  statistic: '',
  isLoading: false,
};

export default AnalyticsCard;
